import { render, staticRenderFns } from "./badge-week.vue?vue&type=template&id=db863df4&scoped=true&"
import script from "./badge-week.vue?vue&type=script&lang=js&"
export * from "./badge-week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db863df4",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex, CButton: require('@chakra-ui/vue').CButton})
